import React, { Component } from 'react'
// import { Tabs } from 'antd';
import img1 from '../../../static/images/solution-super-banner.jpg'
import product3 from '../../../static/images/product-3.png'

import supermarket1 from '../../../static/images/supermarket-solution.png'
import supermarket2 from '../../../static/images/supermarket-2.png'
import supermarket3 from '../../../static/images/supermarket-3.png'

import superIcon1 from '../../../static/images/supuer-icon-1.png'

import advantage1 from '../../../static/images/super-img-1.png'
import advantage2 from '../../../static/images/super-img-2.png'

import analysis1 from '../../../static/images/analysis1.png'



import './index.less';
class SupermarketRetail extends Component {
    state = {
        customerList: [
            { img: superIcon1, title: '促销特价/折扣' },
            { img: superIcon1, title: '单品打折' },
            { img: superIcon1, title: '类别打折' },
            { img: superIcon1, title: '全场打折' },
            { img: superIcon1, title: '供应商打折' },
            { img: superIcon1, title: '组合特价' },
            { img: superIcon1, title: '组合打折' },
            { img: superIcon1, title: '赠品促销' },
            { img: superIcon1, title: '采购促销特价' },
            { img: superIcon1, title: '超量特价' },
            { img: superIcon1, title: '超量折扣' },
            { img: superIcon1, title: '超额折扣' },
            { img: superIcon1, title: '满减' },
            { img: superIcon1, title: '满赠' },
            { img: superIcon1, title: '买M赠N' },
            { img: superIcon1, title: '更多' },
        ],
        partnerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
    }
    onEvents() { }
    render() {
        const { customerList } = this.state
        return (
            <div className="product_container unattended-container affiliate-container supermarket-container pos-container">
                <div className="top-home-carousel">
                    <div className="banner-bg"><img className="banner-img" src={img1} alt="" /></div>
                    <div className="mode-mark"></div>
                    <div className="mask-top-content">
                        <div className="content-pos">
                            <div className="content-left-text">
                                <div className="banner-top-title">悦喵AI-商超零售解决方案</div>
                                <div className="banner-top-tips">面向生鲜超市、连锁超市、大卖场及超市+百货等综合业态提供全面数字化管理系统，涵盖配送中心管理、供应商管理、门店智慧收银和供应链管理，实现线上线下一体化全渠道运营，助力企业迈入智慧零售时代。</div>
                                <div className="banner-top-btn">了解体验</div>
                            </div>
                            
                        </div>
                        
                    </div>
                </div>


                <div className="common-block-home product-page">
                    <div className="common-block-home-title">传统商超行业痛点</div>
                    <div className="common-block-product">
                        <div className="product-detail product-detail-page unattended-first-page">
                            <div className="img-bg">
                                <img className="product-detail-img-icon" src={analysis1} alt="" />
                            </div>
                            
                            <div className="product-detail-title">电商冲击</div>
                            <div className="product-detail-tips">各类线上平台、生鲜团购崛起，冲击线下门店消费，抢占客户源</div>
                        </div>
                        <div className="product-detail product-detail-page unattended-first-page">
                           
                            <div className="img-bg">
                                <img className="product-detail-img-icon" src={analysis1} alt="" />
                            </div>
                            <div className="product-detail-title">门店位置受限</div>
                            <div className="product-detail-tips">门店辐射范围小，依赖顾客到店，客户消费频次低</div>
                        </div>
                        <div className="product-detail product-detail-page unattended-first-page">
                            
                            <div className="img-bg">
                                <img className="product-detail-img-icon" src={analysis1} alt="" />
                            </div>
                            <div className="product-detail-title">管理难题</div>
                            <div className="product-detail-tips">门店商品SKU繁多，数据量大，难以管理</div>
                        </div>
                        <div className="product-detail product-detail-page unattended-first-page">
                            
                            <div className="img-bg">
                                <img className="product-detail-img-icon" src={analysis1} alt="" />
                            </div>
                            <div className="product-detail-title">缺乏线上渠道</div>
                            <div className="product-detail-tips">缺乏专业的线上运营团队，无法链接线上线下客户</div>
                        </div>
                        
                    </div>

                </div>

                <div className="common-block-home">
                    <div className="common-block-home-title">智慧商超解决方案</div>
                    <div className="member-detail-service">
                        <img className="member-img-style" src={supermarket1} alt="" />
                    </div>
                </div>

                <div className="common-block-home advantage-common-block-home">
                    <div className="common-block-home-title">智慧收银 多终端使用<span className="span-color">营销更简单</span></div>

                    <div className="advantage-detail">
                        <div className="advantage-detail-content">
                            <div className="advantage-detail-left">
                                <div className="advantage-detail-left-tips first-style">●  多终端高效收银，称重收银一体化</div>
                                <div className="advantage-detail-left-tips">●  POS会员经营提示，抓着每次营销机会</div>
                                <div className="advantage-detail-left-tips">●  AI智能收银，精准快速识别商品</div>
                                <div className="advantage-btn">立即咨询</div>
                            </div>
                            <div className="advantage-detail-right">
                                <img className="member-img-style" src={advantage1} alt="" />
                            </div>
                        </div>

                    </div>

                </div>

                <div className="common-block-home advantage-common-block-home background-color">
                    <div className="common-block-home-title">商品管理<span className="span-color">多维度更高效</span></div>
                    <div className="advantage-detail background-color">
                        <div className="advantage-detail-content">
                            <div className="advantage-detail-right">
                                <img className="member-img-style" src={advantage2} alt="" />
                            </div>
                            <div className="advantage-detail-left">
                                <div className="advantage-detail-left-tips first-style">●  支持生鲜标品，不同成本多核算方式</div>
                                <div className="advantage-detail-left-tips">●  支持子母码价，多规格销售</div>
                                <div className="advantage-detail-left-tips">●  支持多种价格同时调整，不同成本多核算方式</div>
                                <div className="advantage-btn">立即咨询</div>
                            </div>
                        </div>

                    </div>


                </div>

                {/* <div className="common-block-home">
                    <div className="member-detail-service">
                        <img className="member-img-style" src={supermarket2} alt="" />
                    </div>
                </div> */}
                <div className="common-block-home">
                    <div className="common-block-home-title" style={{marginBottom : 0 ,}}>多种商品维度数据报表</div>
                    <div className="common-block-home-title" style={{ marginTop: 0, }}>全链路分析运营</div>
                    <div className="member-detail-service">
                        <img className="member-img-style" src={supermarket3} alt="" />
                    </div>
                </div>


                <div className="common-block-home supermarket-active">
                    <div className="common-block-home-title">百种营销玩法 瞬间流量变销量</div>
                    <div className="common-block-home-tips">吸粉裂变促转化，多种营销活动促进客户购买，带动商家业绩增长提效</div>
                    <div className="common-block-product">
                        {
                            customerList && customerList.map((item,index) => (
                                <div className="common-model" key={index}>
                                    <div className="common-model-img">
                                        <img className="img-style" src={item.img} alt="" />
                                    </div>
                                    <div className="common-model-title">{item.title}</div>
                                </div>
                            ))
                        }

                    </div>
                </div>

                <div className="common-block-home supermarket-active advantage-common-block-home">
                    <div className="common-block-home-title">全链条精细化管理 降低生鲜损耗</div>
                    <div className="common-block-home-tips">动态监控门店销售情况，以销定采，实现采购、配送、物流和销售等环节耗损监控分析</div>
                    <div className="advantage-detail">
                        <div className="advantage-detail-content">
                            <div className="advantage-detail-left">
                                <div className="advantage-detail-left-tips first-style">●  智能精准订货，以销定采</div>
                                <div className="advantage-detail-left-tips">●  可按时间或库存灵活调价，促销库存</div>
                                <div className="advantage-detail-left-tips">●  全环节损耗监控，责任定位</div>
                                <div className="advantage-btn">立即咨询</div>
                            </div>
                            <div className="advantage-detail-right">
                                <img className="member-img-style" src={advantage1} alt="" />
                            </div>
                        </div>

                    </div>

                </div>

                <div className="common-block-home advantage-common-block-home background-color">
                    <div className="common-block-home-title">会员营销功能全面<span className="span-color">精准营销</span></div>
                    <div className="advantage-detail background-color">
                        <div className="advantage-detail-content">
                            <div className="advantage-detail-right">
                                <img className="member-img-style" src={advantage2} alt="" />
                            </div>
                            <div className="advantage-detail-left">
                                <div className="advantage-detail-left-tips first-style">●  多种会员权益，精准触达，层层激活购买力</div>
                                <div className="advantage-detail-left-tips">●  会员标签管理，分类分层分鲜运营智能营销</div>
                                <div className="advantage-detail-left-tips">●  营销贯穿会员生命周期，深挖单客价值</div>
                                <div className="advantage-btn">立即咨询</div>
                            </div>
                        </div>

                    </div>


                </div>

                <div className="common-block-home advantage-common-block-home margin-bottom">
                    <div className="common-block-home-title">一台手机就可以管好门店<span className="span-color">店务移动化</span></div>
                    <div className="advantage-detail">
                        <div className="advantage-detail-content">
                            <div className="advantage-detail-left">
                                <div className="advantage-detail-left-tips first-style">●  日常店务移动化管控，更省心</div>
                                <div className="advantage-detail-left-tips">●  自定义报表，支持自选模块分析可视化</div>
                                <div className="advantage-detail-left-tips">●  支持多种价格同时调整</div>
                                <div className="advantage-btn">立即咨询</div>
                            </div>
                            <div className="advantage-detail-right">
                                <img className="member-img-style" src={advantage2} alt="" />
                            </div>
                        </div>

                    </div>


                </div>
                
            </div >
        )
    }
}


export default SupermarketRetail